import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { Form } from "react-bootstrap";
import Select from "react-select";
import DataTableLayout from "layouts/DatatableLayout";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { getReportProduct } from "../../redux/handlers/report/getReportProduct.handler";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "moment/locale/th"; // ใส่ locale ไทย
import ReportDateRangeSelect, { getReportDateRange } from "layouts/ReportDateRangeSelect";
export function ReportPurchaseByProduct() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), datalist = _useState[0], setDatalist = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionShop = _useState1[0], setOptionShop = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), shopId = _useState2[0], setShopId = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), optionBranch = _useState3[0], setOptionBranch = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), branchId = _useState4[0], setBranchId = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), optionBrand = _useState5[0], setOptionBrand = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), brandId = _useState6[0], setBrandId = _useState6[1];
    var _useState7 = _sliced_to_array(useState(null), 2), sDate = _useState7[0], setSDate = _useState7[1];
    var _useState8 = _sliced_to_array(useState(null), 2), eDate = _useState8[0], setEDate = _useState8[1];
    var _useState9 = _sliced_to_array(useState("custom"), 2), dateRange = _useState9[0], setDateRange = _useState9[1];
    var _useState10 = _sliced_to_array(useState(""), 2), filterText = _useState10[0], setFilterText = _useState10[1];
    var getReportProductReducer = useAppSelector(function(state) {
        return state.getReportProductReducer;
    });
    // Load data
    useEffect(function() {
        dispatch(getReportProduct({
            sdate: sDate ? moment(sDate).format("YYYY-MM-DD") : "",
            edate: eDate ? moment(eDate).format("YYYY-MM-DD") : "",
            brandid: parseInt(brandId),
            shopid: parseInt(shopId),
            shbranchid: parseInt(branchId),
            searchTxt: filterText
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        shopId,
        brandId,
        sDate,
        eDate,
        branchId,
        filterText
    ]);
    useEffect(function() {
        setIsLoading(getReportProductReducer.isFetching);
        if (getReportProductReducer.data) {
            var data = getReportProductReducer.data.data;
            setDatalist(data);
            var all = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            var sharr = [];
            var bhaarr = [];
            var braarr = [];
            var shopSet = new Set();
            var branchSet = new Set();
            var brandSet = new Set();
            data.forEach(function(ele) {
                if (!shopSet.has(ele.rs_reserve_shid)) {
                    shopSet.add(ele.rs_reserve_shid);
                    sharr.push({
                        value: ele.rs_reserve_shid,
                        label: "".concat(ele.rs_reserve_shopname)
                    });
                }
                if (!branchSet.has(ele.rs_reserve_shbranchid)) {
                    branchSet.add(ele.rs_reserve_shbranchid);
                    bhaarr.push({
                        value: ele.rs_reserve_shbranchid,
                        label: "".concat(ele.rs_reserve_branchname, " (").concat(ele.rs_reserve_shopname, ")")
                    });
                }
                if (!brandSet.has(ele.pd_product_brandid)) {
                    brandSet.add(ele.pd_product_brandid);
                    braarr.push({
                        value: ele.pd_product_brandid,
                        label: ele.set_brand_name
                    });
                }
            });
            setOptionShop(_to_consumable_array(all).concat(_to_consumable_array(sharr)));
            setOptionBranch(_to_consumable_array(all).concat(_to_consumable_array(bhaarr)));
            setOptionBrand(_to_consumable_array(all).concat(_to_consumable_array(braarr)));
        }
    }, [
        getReportProductReducer
    ]);
    var handleDateRangeChange = function(preset) {
        setDateRange(preset);
        var range = getReportDateRange(preset);
        if (range) {
            setSDate(range.startDate);
            setEDate(range.endDate);
        }
    };
    var columns = [
        // {
        //   name: "เดือน",
        //   selector: (row) => moment(row?.date).locale("th").format("MMMM YYYY"),
        //   width: "150px",
        // },
        {
            name: "วันที่สั่ง",
            selector: function(row) {
                return moment(row === null || row === void 0 ? void 0 : row.rs_reserve_approvedate).format("DD-MM-YYYY");
            },
            center: "true",
            width: "150px"
        },
        {
            name: "รหัสสินค้า",
            selector: function(row) {
                return row.pd_product_code;
            },
            center: "true",
            width: "150px"
        },
        {
            name: "แบรนด์",
            selector: function(row) {
                return row.set_brand_name;
            },
            // center: "true",
            width: "180px"
        },
        {
            name: "สินค้า",
            selector: function(row) {
                return row.pd_product_nameth;
            }
        },
        {
            name: "ร้านค้า",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.rs_reserve_shopname;
            },
            // width: "250px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row === null || row === void 0 ? void 0 : row.rs_reserve_shopname,
                        " ( ",
                        row === null || row === void 0 ? void 0 : row.rs_reserve_branchname,
                        " )"
                    ]
                });
            }
        },
        {
            name: "จำนวน",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.total_amount;
            },
            width: "150px",
            center: "true"
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงานสั่งซื้อตามสินค้า"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานสั่งซื้อตามสินค้า"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3 mb-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body px-xl-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-xl-4",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-2 col-md-4",
                                    children: /*#__PURE__*/ _jsx(ReportDateRangeSelect, {
                                        value: dateRange,
                                        onChange: handleDateRangeChange,
                                        controlHeight: 38
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-5 col-md-12",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "row mt-[12px]",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-3 col-md-12",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    className: "mb-2",
                                                    children: "ค้นหาตามช่วงวันที่สั่ง"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-4 col-md-12",
                                                children: /*#__PURE__*/ _jsx(DatePicker, {
                                                    selected: sDate,
                                                    onChange: function(date) {
                                                        setDateRange("custom");
                                                        setSDate(date);
                                                    },
                                                    dateFormat: "dd-MM-yyyy",
                                                    className: "form-control px-2 mb-2",
                                                    isClearable: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-1 col-md-12",
                                                children: /*#__PURE__*/ _jsx("center", {
                                                    className: "mb-2",
                                                    children: "ถึง"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-4 col-md-12",
                                                children: /*#__PURE__*/ _jsx(DatePicker, {
                                                    selected: eDate,
                                                    onChange: function(date) {
                                                        setDateRange("custom");
                                                        setEDate(date);
                                                    },
                                                    dateFormat: "dd-MM-yyyy",
                                                    className: "form-control px-2 mb-2",
                                                    isClearable: true
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-4",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 p-0",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาร้านค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาร้านค้า",
                                                options: optionShop,
                                                value: optionShop.find(function(opt) {
                                                    return opt.value === shopId;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setShopId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-4",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาสาขา"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาสาขา",
                                                options: optionBranch,
                                                value: optionBranch.find(function(opt) {
                                                    return opt.value === branchId;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setBranchId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-4",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาแบรนด์"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาแบรนด์",
                                                options: optionBrand,
                                                value: optionBrand.find(function(opt) {
                                                    return opt.value === brandId;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setBrandId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-4",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control me-3 mt-[12px]",
                                        placeholder: "ค้นหารายการสินค้า",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body pt-0 px-0",
                        children: /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: datalist,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    })
                ]
            })
        ]
    });
}
